module.exports = __webpack_public_path__ + "img/jppdimg_mo1.84cb9d89.png";